import React, { Component } from "react";

export class OnBlurInput extends Component {
  constructor(props) {
    super(props);

    this.state = {
      value: props.value,
      isFocused: false
    };
  }

  onFocus = e => {
    this.setState({ value: this.props.value, isFocused: true });
    this.props.onFocus && this.props.onFocus(e);
  };

  onBlur = e => {
    this.setState({ isFocused: false });
    this.props.onBlur && this.props.onBlur(e);
    this.props.onConfirm && this.props.onConfirm(e);
  };

  onChange = e => {
    this.setState({ value: e.target.value });
    this.props.onChange && this.props.onChange(e);
  };

  render() {
    const props = { ...this.props };
    delete props.onConfirm;
    return (
      <input
        {...props}
        value={this.state.isFocused ? this.state.value : this.props.value}
        onChange={this.onChange}
        onFocus={this.onFocus}
        onBlur={this.onBlur}
      />
    );
  }
}
